<template>
  <div class="login-center" @click="goToPromo">
    <img src="@/assets/images/tg_postnew.png" alt="点击跳转" />
  </div>
</template>
<script>
export default {
  methods: {
    goToPromo() {
      const currentHost = window.location.hostname;
      if (currentHost === 'vip3.getallweb.com' || currentHost === 'vip2.getallweb.com' || currentHost === 'vip4.getallweb.com') {
         window.open(`https://vip2.qqtuku.com`, "_self");
      }else{
        window.open(`https://vip.qqtuku.com`, "_self");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-center {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(128, 128, 128, 0.5);
  cursor: pointer;
  img {
    max-width: 70vw;
    max-height: 70vh;
    width: auto;
    height: auto;
    display: block;
  }
}
</style>
